import * as constants from './constants';

export const userInitialState = {
  profile: null,
  setting: null,
  permissions: null,
};

const userReducer = (state = userInitialState, { type, payload } = {}) => {
  switch (type) {
    case constants.USER_SETTING:
      return {
        ...state,
        setting: payload,
      };
    case constants.USER_PROFILE_DATA:
      return {
        ...state,
        profile: payload,
      };
    case constants.USER_PERMISSIONS:
      return {
        ...state,
        permissions: payload,
      };
    default:
      return state;
  }
};

export default userReducer;
